module.exports = __webpack_public_path__ + "img/20_43.33bebcb0.png";